import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-order-status-radio-buttons',
  templateUrl: './order-status-radio-buttons.component.html',
  styleUrls: ['./order-status-radio-buttons.component.scss'],
})
export class OrderStatusRadioButtonsComponent implements OnInit, OnDestroy {
  public status: string[] = [];
  public selected: string = '';
  @Input() public control: UntypedFormControl = new UntypedFormControl();
  @Input() public fromAlerts = false;
  private onDestroy$: Subject<void> = new Subject<void>();

  public valueChanged() {
    this.control.setValue(this.selected);
  }

  public ngOnInit() {
    if (this.fromAlerts) {
      this.status = [
        'Partial',
        'Final',
        'All',
      ];
      this.selected = this.status[2];
    } else {
      this.status = [
        'Pending',
        'Partial',
        'Final',
        'All',
      ];
      this.selected = this.status[3];
    }

    this.valueChanged();

    this.control.valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe((values) => {
      if (values === undefined || values === null) {
        this.selected = this.fromAlerts ? this.status[2] : this.status[3];
      }
    });
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete()
  }
}
